/*
 * @Author: 张斌
 * @Date: 2022-04-08 10:05:58
 * @LastEditors: 张斌
 * @LastEditTime: 2022-04-11 16:24:24
 */
import * as account from './modules/account'
import * as user from './modules/user'
import * as department from './modules/department'
import * as common from './modules/common'
import * as stats from './modules/stats'
import * as dev from './modules/dev'
import * as param from './modules/param'



export default {
  ...account,
  ...user,
  ...department,
  ...common,
  ...stats,
  ...dev,
  ...param
}
